module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/utilities/Dialog/dialog/prompt-dialog/prompt-dialog.component.css
// module id = ./src/app/utilities/Dialog/dialog/prompt-dialog/prompt-dialog.component.css
// module chunks = main